import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import { useGalleryImageContext } from "../../context/GalleryContext";

const AlbumsGrid = () => {
  const { galleryImageData } = useGalleryImageContext();
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const weekday = new Intl.DateTimeFormat("en-GB", {
      weekday: "long",
    }).format(date);
    const formattedDate = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
    return `${weekday}, ${formattedDate}`;
  };
  const images = galleryImageData?.map((data) => {
    return {
      id: data?.id,
      title: data?.title,
      date: formatDate(data?.date),
      thumbnail: data?.thumbnail[0]?.media?.url,
    };
  });
  // const images = [
  //   {
  //     id: 1,
  //     title: "Aria’s 6th Birthday",
  //     date: "Saturday, 09 Nov 2024",
  //     image: imageUrl,
  //   },
  //   {
  //     id: 2,
  //     title: "Event 1",
  //     date: "Tuesday, 15 Oct 2024",
  //     image: imageUrl11,
  //   },
  //   {
  //     id: 3,
  //     title: "Event 2",
  //     date: "Tuesday, 10 Sep 2024",
  //     image: imageUrl14,
  //   },
  // ];

  return (
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-541c8ac elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="541c8ac"
        data-element_type="section"
        data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
      >
        <div className="elementor-container elementor-column-gap-default">
          <div className="elementor-row">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-57c29cf"
              data-id="57c29cf"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <Fade cascade damping={0.2} direction="up" triggerOnce={true}>
                    <div
                      className="elementor-element elementor-element-421b618 elementor-widget elementor-widget-heading"
                      data-id="421b618"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default">
                          Hotel BayBerry Albums
                        </h2>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-c2041e4 elementor-widget elementor-widget-text-editor"
                      data-id="c2041e4"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <div className="elementor-text-editor elementor-clearfix">
                          <p>
                            A collection of memories that can be shared and
                            enjoyed for years to come
                          </p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-8a8a326 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8a8a326"
        data-element_type="section"
        data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
      >
        <div className="elementor-container elementor-column-gap-default">
          <div className="elementor-row">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d3af3af"
              data-id="d3af3af"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <Fade direction="up" triggerOnce={true}>
                    <div
                      className="elementor-element elementor-element-c222a70 elementor-widget elementor-widget-hoteller-gallery-grid"
                      data-id="c222a70"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="hoteller-gallery-grid.default"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <div className="elementor-widget-container">
                        <div
                          className="gallery_grid_content_wrapper layout_tg_three_cols custom-layout_tg_three_cols"
                          style={{
                            display: "grid",
                            gap: "20px",
                            padding: "0 15%",
                            gridTemplateColumns: "repeat(3, 1fr)",
                          }}
                        >
                          {images.map((image, index) => (
                            <Link
                              to="/gallery/gallery-view"
                              state={{
                                id: image.id,
                              }}
                            >
                              <div
                                key={index}
                                className="gallery_grid_item tg_three_cols gallery-grid-tilt custom-gallery-album"
                                style={{
                                  position: "relative",
                                  cursor: "pointer",
                                  height: "450px",
                                  overflow: "hidden",
                                }}
                              >
                                <img
                                  src={
                                    image?.thumbnail
                                      ? `${process.env.REACT_APP_cmsUrl}${image?.thumbnail}`
                                      : "https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png"
                                  }
                                  alt="gallery"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                                <div
                                  style={{
                                    position: "absolute",
                                    bottom: "0px",
                                    padding: "3em",
                                    zIndex: 2,
                                  }}
                                >
                                  <h3 className="custom-gallery-album-h3">
                                    {image.title}
                                  </h3>
                                  <p className="custom-gallery-album-p">
                                    {image.date}
                                  </p>
                                </div>
                                <div className="custom-gradient"></div>
                              </div>
                            </Link>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AlbumsGrid;
